export class TableContextKinds {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "kindColumn",
            "baseName": "kindColumn",
            "type": "string",
            "format": ""
        },
        {
            "name": "sampleHours",
            "baseName": "sampleHours",
            "type": "number",
            "format": ""
        },
        {
            "name": "sampleRows",
            "baseName": "sampleRows",
            "type": "number",
            "format": ""
        },
        {
            "name": "everyKindFills",
            "baseName": "everyKindFills",
            "type": "Array<string>",
            "format": ""
        },
        {
            "name": "notRead",
            "baseName": "notRead",
            "type": "Array<string>",
            "format": ""
        },
        {
            "name": "kinds",
            "baseName": "kinds",
            "type": "Array<TableContextKind>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return TableContextKinds.attributeTypeMap;
    }
    constructor() {
    }
}
